/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_Tags_AllInputs */

const cs_clients_filter_tags_all = /** @type {(inputs: Clients_Filter_Tags_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny vybrané štítky`)
};

const en_clients_filter_tags_all = /** @type {(inputs: Clients_Filter_Tags_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All selected tags`)
};

/**
* | output |
* | --- |
* | "All selected tags" |
*
* @param {Clients_Filter_Tags_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_tags_all = /** @type {((inputs?: Clients_Filter_Tags_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_Tags_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_tags_all(inputs)
	return cs_clients_filter_tags_all(inputs)
});